import React, {useEffect} from 'react';
import {browserHistory} from 'react-router';

import LibrarySearchTab from 'components/pure/library/LibrarySearchTab';
import LibraryCreateTab from 'components/pure/library/LibraryCreateTab';
import LibraryBrowseTab from 'components/pure/library/LibraryBrowseTab';

import {LIBRARY_ROUTE, libraryLinkName} from '@store/library/library.consts';
import User from 'records/User';
import {makeStyles} from '@material-ui/core/styles';

interface LibrarySearchFormProps {
  user: User;
  // TODO clean up anys
  searchInfo: any;
  formState: any;
  sources: any;
  searchCalls: boolean;
  fetchLibrariesData: () => Promise<void>;
  updateLibraryDropdown: (library: string) => void;
}

export const LibrarySearchForm: React.FC<LibrarySearchFormProps> = ({
  user,
  searchCalls,
  searchInfo,
  formState,
  sources,
  fetchLibrariesData,
  updateLibraryDropdown,
}) => {
  useEffect(() => {
    if (searchCalls) {
      // if searchCalls redirect to library/search page
      browserHistory.replace(LIBRARY_ROUTE.SEARCH);
    } else {
      // fetch all library data
      fetchLibrariesData().then().catch(console.error);

      // update library Dropdown to initial value
      updateLibraryDropdown('any');
    }
  }, [fetchLibrariesData, searchCalls, updateLibraryDropdown]);

  const css = useStyles();
  return (
    <div>
      <div className="library-container">
        <div className={css.flex}>
          <h1>{libraryLinkName(user)}</h1>
          <span className={css.subheader}>Notable calls, organized by tags.</span>
        </div>
        <div className="row library-search-header">
          <LibrarySearchTab formState={formState} searchInfo={searchInfo} sources={sources} />
          <LibraryCreateTab />
        </div>
        <div className="row">
          <LibraryBrowseTab sources={sources} />
        </div>
      </div>
    </div>
  );
};

const useStyles = makeStyles(theme => ({
  subheader: {
    marginLeft: 30,
  },
  flex: {
    display: 'flex',
    alignItems: 'flex-end',
    marginTop: 30,
    marginBottom: 30,
  },
}));
